'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Icon } from '@/ui/icons/icon/Icon'
import { Loader } from '@/ui/loaders/loader/Loader'

type SelectTriggerChromeProps = {
  showLoader: boolean
  isDisabled: boolean
  isOpen: boolean
}

export function SelectTriggerChrome({ showLoader, isDisabled, isOpen }: SelectTriggerChromeProps) {
  return (
    <span aria-hidden="true" className="shrink-0">
      {showLoader ? (
        <Loader className="text-primary" />
      ) : (
        <Icon.ChevronDown
          size="md"
          className={twMerge(
            'transition-transform duration-200',
            isDisabled ? 'text-brand-2-400' : 'text-brand-2-900',
            isOpen && '-rotate-180',
          )}
        />
      )}
    </span>
  )
}
